module.exports = __webpack_public_path__ + "static/media/everyday_digital_footy2024.ad12c5e1.png";